__turbopack_context__.v({
  "BookCard": "BookCard-module__-gbP6G__BookCard",
  "BookCardHeading": "BookCard-module__-gbP6G__BookCardHeading",
  "book-card-description": "BookCard-module__-gbP6G__book-card-description",
  "columns": "BookCard-module__-gbP6G__columns",
  "row": "BookCard-module__-gbP6G__row",
  "slider-details": "BookCard-module__-gbP6G__slider-details",
  "slider-image": "BookCard-module__-gbP6G__slider-image",
  "text-gradient-overlay": "BookCard-module__-gbP6G__text-gradient-overlay",
});
